import React, { ReactNode } from 'react';
import styles from './styles.module.css';

interface PillProps {
  children: ReactNode;
  color?: string;
  bg?: string;
  icon?: ReactNode;
  /** Show a leading dot; `pulse` makes it blink (live indicator). */
  dot?: boolean;
  pulse?: boolean;
  className?: string;
}

/** Small rounded status label (tags, counts, live indicators). */
export function Pill({ children, color, bg, icon, dot, pulse, className = '' }: PillProps) {
  return (
    <span className={`${styles.pill} ${className}`} style={{ color, background: bg }}>
      {dot ? (
        <span className={styles.dot} data-pulse={pulse} style={{ background: color }} />
      ) : null}
      {icon}
      {children}
    </span>
  );
}
